
/** manager.ManagerStore Module initialization */
angular.module('manager.managerStore', [])
.service('ManagerStore', require('./ManagerStore'))
.run(['ManagerStore', function (ManagerStore) {
  ManagerStore.init();
}]);



// WEBPACK FOOTER //
// ./src/app/manager/dataStores/index.js